import * as types from '../constants/ActionTypes';

export function commentReceived(payload) {
  return {
    type: types.COMMENTS_GET + types.SUCCESS,
    payload
  };
}

export function commentFetching() {
  return {
    type: types.COMMENTS_GET + types.FETCHING
  };
}

export function commentFail() {
  return {
    type: types.COMMENTS_GET + types.FAIL
  };
}

export function commentPosted(payload) {
  return {
    type: types.COMMENTS_POST + types.SUCCESS,
    payload
  };
}
